import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ApiResponse } from '@/api/handlers/responses';
import { BranchQueryKeys } from './branchQueryKeys';

export type SetBranchArchivedVariables = {
    id: string;
    archived: boolean;
};

/**
 * Archives or unarchives a branch (BOS-121) — what a branch with sales, invoices
 * or an active POS device token gets instead of a delete. Its sales stay in
 * branch comparison for the ranges it traded in; only the pickers and the device
 * exchange stop accepting it.
 */
export const useSetBranchArchivedMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<ApiResponse<unknown>, Error, SetBranchArchivedVariables>(
        {
            mutationFn: ({ id, archived }) =>
                apiClient.branches.setBranchArchived(id, archived),
            onSuccess: (result) => {
                if (result.success) {
                    queryClient.invalidateQueries({
                        queryKey: BranchQueryKeys.all,
                    });
                }
            },
        },
    );
};
